import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Utils
// Constants
// Actions
// Models
// Interfaces
// Components
import { WarningBanner } from '@toolkit/ui';

type Props = {
  requiresAllowance: boolean;
};

export const RequiresAllowanceWarning: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  if (props.requiresAllowance) {
    return (
      <WarningBanner
        type="info"
        title={t('requiresAllowanceWarning.requestAllownace.title')}
        label={t('requiresAllowanceWarning.requestAllowance.message')}
      />
    );
  }
};
